'use client'
import React, { FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import { MktuClass } from '@/services/Api/generated'

import styles from './MktuClassButton.module.scss'

interface MktuClassButtonProps {
  className?: string
  classNumber: MktuClass['classNumber']
  isSelected?: boolean
  onMouseEnter?: (classNumber: MktuClass['classNumber']) => void
  onMouseLeave?: (classNumber: MktuClass['classNumber']) => void
  onClick?: (classNumber: MktuClass['classNumber']) => void
}
export const MktuClassButton: FunctionComponent<MktuClassButtonProps> = ({
  className,
  classNumber,
  isSelected = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const click = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (onClick != null) {
        onClick(classNumber)
      }
    },
    [classNumber, onClick]
  )

  const mouseEnter = useCallback(() => {
    if (onMouseEnter != null) {
      onMouseEnter(classNumber)
    }
  }, [classNumber, onMouseEnter])

  const mouseLeave = useCallback(() => {
    if (onMouseLeave != null) {
      onMouseLeave(classNumber)
    }
  }, [classNumber, onMouseLeave])

  return (
    <button
      type="button"
      className={cn(styles.container, className, {
        [styles.isSelected]: isSelected,
      })}
      data-testid={`mktuClassButton_${classNumber}`}
      onClick={click}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      {classNumber}
    </button>
  )
}
